import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const crmAttributionRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/crm/attribution",
  component: lazyRouteComponent(() => import("./crm-attribution.page.js"), "CrmAttributionPage"),
});
